import { BaseModel } from "../../../vendor_core/core/src/model/BaseModel";
import {
    BURSpinData,
    CoinColor,
    EnergyCoinData,
    MaybeUndefined,
    PointLike
} from "../types/BURGameTypes";
import {
    BaseGameFeature,
    BURFreeSpinsData,
    IBURFeatureData
} from "../types/IBURFeatureModel";

class BURFeatureModel extends BaseModel<IBURFeatureData> {
    private willBaseGameFeatureTrigger: boolean = false;
    private willFreeSpinsTrigger: boolean = false;
    private baseGameFeaturesToTrigger: BaseGameFeature[] = [];
    private randomWildsPositions: PointLike[] = [];
    private energyCoins: EnergyCoinData[] = [];
    private replayEnergyCoins: EnergyCoinData[] = [];
    private mysteryEnergyCoins: EnergyCoinData[] = [];
    private mysteryCoinFlipId: number = 0;
    private blueRespinData: MaybeUndefined<BURSpinData> = undefined;
    private freeSpinsData: MaybeUndefined<BURFreeSpinsData> = undefined;

    private featureHasStickyWilds = false;

    public get will_base_game_feature_trigger(): boolean {
        return this.willBaseGameFeatureTrigger;
    }

    public get will_free_spins_trigger(): boolean {
        return this.willFreeSpinsTrigger;
    }

    public get base_game_features_to_trigger(): BaseGameFeature[] {
        return this.baseGameFeaturesToTrigger;
    }

    public get random_wilds_positions(): PointLike[] {
        return this.randomWildsPositions;
    }

    public get feature_has_sticky_wilds(): boolean {
        return this.featureHasStickyWilds;
    }

    /**
     * Energy coins from the energy charge feature
     */
    public get energy_coins(): EnergyCoinData[] {
        return this.energyCoins;
    }

    /**
     * Energy coins in the replay spin
     * To be used only in recover state
     */
    public get replay_energy_coins(): EnergyCoinData[] {
        return this.replayEnergyCoins;
    }

    /**
     * Energy coins from mystery symbols flips
     */
    public get mystery_energy_coins(): EnergyCoinData[] {
        return this.mysteryEnergyCoins;
    }

    /**
     * When the mystery symbol transforms into an energy coin, this is the symbol that the coin then transforms into
     */
    public get mystery_coin_flip_id(): number {
        return this.mysteryCoinFlipId;
    }

    public get blue_respin_data(): MaybeUndefined<BURSpinData> {
        return this.blueRespinData;
    }

    public get free_spins_data(): MaybeUndefined<BURFreeSpinsData> {
        return this.freeSpinsData;
    }

    public setWillBaseGameFeatureTrigger(payload: boolean) {
        this.willBaseGameFeatureTrigger = payload;
    }

    public setWillFreeSpinsTrigger(payload: boolean) {
        this.willFreeSpinsTrigger = payload;
    }

    public addBaseGameFeatureToTrigger(payload: BaseGameFeature) {
        this.baseGameFeaturesToTrigger.push(payload);
    }

    public clearBaseGameFeaturesToTrigger() {
        this.baseGameFeaturesToTrigger = [];
    }

    public setRandomWildsPositions(payload: PointLike[]) {
        this.randomWildsPositions = payload;
    }

    public setEnergyCoins(payload: EnergyCoinData[]) {
        this.energyCoins = payload;
    }

    public setMysteryEnergyCoins(payload: EnergyCoinData[]) {
        this.mysteryEnergyCoins = payload;
    }

    public setReplayEnergyCoins(payload: EnergyCoinData[]) {
        this.replayEnergyCoins = payload;
    }

    public setMysteryCoinFlipId(payload: number) {
        this.mysteryCoinFlipId = payload;
    }

    public setBlueRespinData(payload: MaybeUndefined<BURSpinData>) {
        this.blueRespinData = payload;
    }

    public setFreeSpinsData(payload: MaybeUndefined<BURFreeSpinsData>) {
        this.freeSpinsData = payload;
    }

    public setFeatureHasStickyWilds(payload: boolean) {
        this.featureHasStickyWilds = payload;
    }
}

export default new BURFeatureModel();
